import { alpha, CircularProgress, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly loading: boolean;
}

export const FullScreenLoader: React.FC<Props> = (props: Props): React.ReactElement => {
  const theme = useTheme();

  const { loading } = props;

  const backgroundColor = React.useMemo((): string => {
    const { background } = theme.palette;
    return alpha(background.paper, 0.75);
  }, [theme.palette]);

  if (!loading) {
    return <></>;
  }

  return (
    <Box sx={styles.container} bgcolor={backgroundColor}>
      <CircularProgress size={64} thickness={5} />
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    backdropFilter: 'grayscale(40%) blur(3px)',
    borderRadius: 'inherit',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
  },
};
